<dashboard-dialog-frame class="dropout-dialog" [header]="header()" [dialogRef]="dialogRef">

	<div class="d-flex flex-column justify-content-between h-100 p-3">
		<div class="d-flex flex-column gap-2">
			<common-select-field [field]="dropoutForm.dropOutWeek()"></common-select-field>

			<!-- TODO: Create a new select field widget to have the same look and feel as the descriptive select field for subText and icon -->
			<common-select-field class="d-none" [field]="dropoutForm.dropoutReason()"></common-select-field>
			<dashboard-descriptive-select-field [showSubTextInValue]="false" [items]="dropoutForm.descriptiveStatusItems()"
				[selectedItem]="dropoutForm.selectedDescriptiveItem()" [placeholder]="'Select a Reason...'"
				label="Drop-out Reason" [enableSorting]="false"
				(selectionChange)="dropoutForm.onDescriptiveSelectionChange($event)">
			</dashboard-descriptive-select-field>

			<common-text-field [field]="dropoutForm.note()"></common-text-field>

			@if(dropoutDetails(); as dropoutDetails){
			<div class="d-flex justify-content-between mb-3">
				<table class='pro-table pro-table-no-background pro-table-with-labels pro-table-without-border'>
					<tr>
						<td>Dropped By</td>
						<td>{{dropoutDetails.createdByStaff}}</td>
					</tr>
					<tr>
						<td>Dropped On</td>
						<td>{{dropoutDetails.formattedCreatedDate}}</td>
					</tr>
				</table>
				<table class='pro-table pro-table-no-background pro-table-with-labels pro-table-without-border'>
					<tr>
						<td>Updated By</td>
						<td>{{dropoutDetails.updatedByStaff}}</td>
					</tr>
					<tr>
						<td>Updated On</td>
						<td>{{dropoutDetails.formattedUpdatedDate}}</td>
					</tr>
				</table>
			</div>
			}
		</div>

		<common-button-row [center]="true">
			<button #formSaveBtn class="btn btn-primary">{{dropoutDetails() ? 'Update' : 'Mark Dropped-out'}}</button>
			<button class="btn btn-standard" (click)="resetForm()">Revert</button>
			<button class="btn btn-standard" (click)="dialogRef.close()">Cancel</button>
		</common-button-row>
	</div>
</dashboard-dialog-frame>